import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { recipes } from "./data";
import RecipeCard from "./RecipeCard";
import RecipeSearchInterface from "./RecipeSearchInterface";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import { GetAllDietPlanServices } from "../../../../core/store/diet/dietPan/thunk";
import { Pagination } from "react-bootstrap";


const ITEMS_PER_PAGE = 20;

const Recettes = () => {
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
    useEffect(() => {
        dispatch(GetAllDietPlanServices());    
    }, [dispatch]);

    const selectLayoutState = (state) => state.DietPlan;
    const loginpageData = createSelector(
        selectLayoutState,
        (state) => ({
            error: state.error,
            loading: state.loading,
            dietPlans: state.dietPlans,
        })
    );

    const { error, loading, dietPlans } = useSelector(loginpageData);

    console.log("Données récupérées (dietPlans):", dietPlans);

    // Calcul des données de pagination
    const totalItems = dietPlans && Array.isArray(dietPlans) ? dietPlans.length : 0;
    const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const currentRecipes = dietPlans && Array.isArray(dietPlans) ? dietPlans.slice(startIndex, endIndex) : [];

    // Réinitialiser la page si on dépasse le nombre total de pages
    useEffect(() => {
        if (totalPages > 0 && currentPage > totalPages) {
            setCurrentPage(1);
        }
    }, [totalPages, currentPage]);

    // Gestion de la pagination
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Génération des numéros de pages
    const generatePaginationItems = () => {
        const items = [];
        const maxVisiblePages = 5;
        
        if (totalPages <= maxVisiblePages) {
            for (let i = 1; i <= totalPages; i++) {
                items.push(
                    <Pagination.Item
                        key={i}
                        active={i === currentPage}
                        onClick={() => handlePageChange(i)}
                    >
                        {i}
                    </Pagination.Item>
                );
            }
        } else {
            let startPage = Math.max(1, currentPage - 2);
            let endPage = Math.min(totalPages, currentPage + 2);

            if (currentPage <= 3) {
                endPage = 5;
            } else if (currentPage >= totalPages - 2) {
                startPage = totalPages - 4;
            }

            if (startPage > 1) {
                items.push(
                    <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
                        1
                    </Pagination.Item>
                );
                if (startPage > 2) {
                    items.push(<Pagination.Ellipsis key="start-ellipsis" />);
                }
            }

            for (let i = startPage; i <= endPage; i++) {
                items.push(
                    <Pagination.Item
                        key={i}
                        active={i === currentPage}
                        onClick={() => handlePageChange(i)}
                    >
                        {i}
                    </Pagination.Item>
                );
            }

            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    items.push(<Pagination.Ellipsis key="end-ellipsis" />);
                }
                items.push(
                    <Pagination.Item
                        key={totalPages}
                        onClick={() => handlePageChange(totalPages)}
                    >
                        {totalPages}
                    </Pagination.Item>
                );
            }
        }

        return items;
    };

    if (loading) {
        return (
            <>
                <div id="preloader">
                    <div className="sk-three-bounce">
                        <div className="sk-child sk-bounce1"></div>
                        <div className="sk-child sk-bounce2"></div>
                        <div className="sk-child sk-bounce3"></div>
                    </div>
                </div>  
            </>
        );
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <>
    
    
            <div className="container">


               <div className="row mb-5">
                <div style={{marginTop:"-3.5rem"}} className="col-12 text-center">
                    <h2
                    className="fw-bold animate__animated animate__fadeInDown"
                    style={{
                        fontSize: "2rem",
                        background: "linear-gradient(135deg, #7fce4a, #7ed456)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        textShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        letterSpacing: "1.2px",
                        transition: "transform 0.3s ease",
                       
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                    >
                    <i className="fa fa-seedling me-3" style={{ fontSize: "2rem" }}></i>
                    Inspiration Culinaire – Nos Recettes
                    </h2>

                   
                </div>
                </div>




                {/* Informations sur la pagination */}
           {totalItems > 0 && (
                    <div  className="row mb-3">
                        <div style={{marginTop:"-1rem", marginBottom : "1rem"}} className="col-12">
                            <div  className="d-flex justify-content-between align-items-center">
                                <div 
                                >
                                   
                                </div>

                                <div className="page-info" style={{
                                    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                    color: '#495057',
                                    padding: '8px 16px',
                                    borderRadius: '20px',
                                    fontSize: '0.85rem',
                                    fontWeight: '600',
                                    border: '2px solid #dee2e6',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    transition: 'all 0.3s ease',
                                    cursor: 'default'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'scale(1.05)';
                                    e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'scale(1)';
                                    e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                                }}
                                >
                                    <i className="fa fa-bookmark me-2"></i>
                                    Page {currentPage} sur {totalPages}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Grille des recettes */}
                <div className="row">
                    {currentRecipes.map((recipe, index) => (
                        <div key={`${recipe.id || index}-${currentPage}`} className="col-lg-3 col-md-6 col-sm-12 mb-4">
                            <RecipeCard recipe={recipe} />
                        </div>
                    ))}
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="d-flex justify-content-center">
                                <Pagination size="lg">
                                    <Pagination.First
                                        onClick={() => handlePageChange(1)}
                                        disabled={currentPage === 1}
                                    />
                                    <Pagination.Prev
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    />
                                    
                                    {generatePaginationItems()}
                                    
                                    <Pagination.Next
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    />
                                    <Pagination.Last
                                        onClick={() => handlePageChange(totalPages)}
                                        disabled={currentPage === totalPages}
                                    />
                                </Pagination>
                            </div>
                        </div>
                    </div>
                )}

                {/* Pagination mobile */}
                <div className="row mt-3 d-md-none">
                    <div className="col-12">
                        <div className="d-flex justify-content-between">
                            <button
                                className="btn btn-outline-primary"
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                ← Précédent
                            </button>
                            <span className="align-self-center">
                                {currentPage} / {totalPages}
                            </span>
                            <button
                                className="btn btn-outline-primary"
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                Suivant →
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Recettes;